export default "__VITE_ASSET__7017bd09__"